module.exports = __webpack_public_path__ + "img/menu.28aab7ea.svg";